export default __webpack_public_path__ + "static/media/audio-fail.d4d9e545.mp3";